/* ROOTED — section behaviour (gallery, bundle selector, add to cart, sticky bar, reviews) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (root.__rt) return;
    root.__rt = true;
    var track = $('[data-rt-track]', root);
    if (!track) return;
    var slides = $$('[data-rt-slide]', root);
    var thumbs = $$('[data-rt-thumb]', root);
    var cur = $('[data-rt-current]', root);
    var idx = 0;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function setActive(i) {
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (cur) cur.textContent = i + 1;
      var t = thumbs[i];
      if (!t) return;
      var box = t.parentElement;
      var tr = t.getBoundingClientRect();
      var br = box.getBoundingClientRect();
      if (box.scrollWidth > box.clientWidth + 2) {
        box.scrollTo({ left: box.scrollLeft + (tr.left - br.left) - box.clientWidth / 2 + tr.width / 2, behavior: 'smooth' });
      } else if (box.scrollHeight > box.clientHeight + 2) {
        box.scrollTo({ top: box.scrollTop + (tr.top - br.top) - box.clientHeight / 2 + tr.height / 2, behavior: 'smooth' });
      }
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { go(k); setActive(k); });
    });
    var prev = $('[data-rt-prev]', root);
    var next = $('[data-rt-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
  }

  /* ---------- Bundle selector + add to cart ---------- */
  function initBundle(form) {
    if (form.__rt) return;
    form.__rt = true;
    var tiers = $$('[data-rt-tier]', form);
    var sub = $('[data-rt-sub]', form);
    var subWrap = $('[data-rt-sub-wrap]', form);
    var noteSub = $('[data-rt-note-sub]', form);
    var noteOnce = $('[data-rt-note-once]', form);
    var btn = $('[data-rt-atc]', form);
    var buyOnce = $('[data-rt-buy-once]', form);
    var buyOncePrice = $('[data-rt-buy-once-price]', form);
    var err = $('[data-rt-error]', form);
    var pdp = form.closest('[data-rt-pdp]');
    var mainPrice = pdp ? $('[data-rt-main-price]', pdp) : null;
    var mainCompare = pdp ? $('[data-rt-main-compare]', pdp) : null;

    function isSub() { return !!(sub && sub.checked); }
    function selected() {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].classList.contains('is-selected')) return tiers[i];
      return tiers[0];
    }
    function render() {
      var on = isSub();
      tiers.forEach(function (t) {
        var p = $('[data-rt-price]', t);
        if (p) p.textContent = on ? t.dataset.sub : t.dataset.once;
        var sv = $('[data-rt-save]', t);
        if (sv) sv.textContent = on ? t.dataset.saveSub : t.dataset.saveOnce;
        var d = $('[data-rt-day]', t);
        if (d) d.textContent = on ? t.dataset.daySub : t.dataset.dayOnce;
      });
      if (subWrap) subWrap.classList.toggle('is-checked', on);
      if (noteSub) noteSub.hidden = !on;
      if (noteOnce) noteOnce.hidden = on;
      if (buyOnce) buyOnce.hidden = !on;
      var s = selected();
      if (s) {
        if (mainPrice) mainPrice.textContent = on ? s.dataset.sub : s.dataset.once;
        if (mainCompare) mainCompare.textContent = s.dataset.compare;
        if (btn) btn.disabled = s.dataset.available === 'false';
        if (buyOnce) buyOnce.disabled = s.dataset.available === 'false';
        if (buyOncePrice) buyOncePrice.textContent = s.dataset.once;
        if (sub && s.dataset.planId) sub.value = s.dataset.planId;
      }
    }

    tiers.forEach(function (t) {
      var input = $('input', t);
      if (!input) return;
      input.addEventListener('change', function () {
        tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
        render();
      });
    });
    if (sub) sub.addEventListener('change', render);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(isSub(), btn);
    });
    if (buyOnce) buyOnce.addEventListener('click', function () { addToCart(false, buyOnce); });

    function addToCart(withPlan, trigger) {
      var s = selected();
      if (!s || !btn || btn.disabled) return;
      var fd = new FormData();
      fd.append('id', s.dataset.variantId);
      fd.append('quantity', '1');
      if (withPlan && s.dataset.planId) fd.append('selling_plan', s.dataset.planId);

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      if (canRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      trigger.classList.add('is-loading');
      btn.disabled = true;
      if (buyOnce) buyOnce.disabled = true;
      if (err) err.hidden = true;
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          var data = r.data || {};
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Sorry, something went wrong. Please try again.');
          document.dispatchEvent(new CustomEvent('rooted:cart-added', { detail: data }));
          if (canRender && data.sections) {
            cart.renderContents(data);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        })
        .finally(function () {
          trigger.classList.remove('is-loading');
          render();
        });
    }

    render();
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky(pdp) {
    if (pdp.__rtSticky) return;
    pdp.__rtSticky = true;
    var bar = $('[data-rt-sticky]', pdp);
    var form = $('[data-rt-bundle]', pdp);
    var atc = form ? $('[data-rt-atc]', form) : null;
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var sbtn = $('[data-rt-sticky-btn]', bar);
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('rt-sticky-on', show);
      if (sbtn) sbtn.tabIndex = show ? 0 : -1;
    });
    io.observe(atc);
    if (sbtn) sbtn.addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Reviews: read more ---------- */
  function initReviews(root) {
    $$('[data-rt-review]', root).forEach(function (card) {
      if (card.__rt) return;
      card.__rt = true;
      var t = $('.rt-review__text', card);
      var b = $('[data-rt-more]', card);
      if (!t || !b) return;
      requestAnimationFrame(function () {
        if (t.scrollHeight <= t.clientHeight + 2) b.hidden = true;
      });
      b.addEventListener('click', function () {
        var ex = card.classList.toggle('is-expanded');
        b.textContent = ex ? 'Read less' : 'Read more';
      });
    });
  }

  /* ---------- Horizontal scroller arrows ---------- */
  function initScrollers(root) {
    $$('[data-rt-scroller-wrap]', root).forEach(function (w) {
      if (w.__rt) return;
      w.__rt = true;
      var sc = $('[data-rt-scroller]', w);
      if (!sc) return;
      function step() {
        var f = sc.firstElementChild;
        return f ? f.getBoundingClientRect().width + 24 : sc.clientWidth;
      }
      var p = $('[data-rt-scroll-prev]', w);
      var n = $('[data-rt-scroll-next]', w);
      if (p) p.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Countdown bar: rolling timer that restarts every N hours ---------- */
  function initCountdown(el) {
    if (el.__rt) return;
    el.__rt = true;
    var cycle = Math.max(1, parseInt(el.dataset.cycleHours, 10) || 6) * 3600000;
    var parts = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { parts[k] = $('[data-rt-cd="' + k + '"]', el); });
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      if (!el.isConnected) return;
      var now = Date.now();
      // Windows are aligned to the clock, so every visitor and page load shows the same time left.
      var left = Math.max(0, Math.ceil(now / cycle) * cycle - now);
      var secs = Math.floor(left / 1000);
      var d = Math.floor(secs / 86400);
      var h = Math.floor((secs % 86400) / 3600);
      if (!parts.d) h += d * 24;
      if (parts.d) parts.d.textContent = pad(d);
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(Math.floor((secs % 3600) / 60));
      if (parts.s) parts.s.textContent = pad(secs % 60);
      setTimeout(tick, 1000 - (now % 1000) + 5);
    }
    tick();
  }

  function init(root) {
    root = root || document;
    $$('[data-rt-countdown]', root).forEach(initCountdown);
    $$('[data-rt-gallery]', root).forEach(initGallery);
    $$('[data-rt-bundle]', root).forEach(initBundle);
    $$('[data-rt-pdp]', root).forEach(initSticky);
    initReviews(root);
    initScrollers(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
